import { render, staticRenderFns } from "./CardCartTicket.vue?vue&type=template&id=8bb3fa10&scoped=true&"
import script from "./CardCartTicket.vue?vue&type=script&lang=js&"
export * from "./CardCartTicket.vue?vue&type=script&lang=js&"
import style0 from "./CardCartTicket.vue?vue&type=style&index=0&id=8bb3fa10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb3fa10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCard,VCheckbox})
